"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator_clientSyncWorld = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var voyageMessageRequestGamestate_sidecar_1 = require("@voyage/multi/voyageMessageRequestGamestate-sidecar");
var voyageShipSaver_sidecar_1 = require("@voyage/saver/voyageShipSaver-sidecar");
var voyageGameMode_game_processShipFile_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_game_processShipFile-sidecar");
var voyageGameMode_scenario_new_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_scenario_new-sidecar");
var voyageMenuMain_sidecar_1 = require("@voyage/ui/voyageMenuMain-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var namespace = 'voyage-client-sync-world';
function generator_clientSyncWorld() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log(namespace, 'start');
                voyageMenuMain_sidecar_1.voyageMenuMain.setOpen(false);
                if (!!voyageWebsockets_sidecar_1.voyageWebsockets.getIsSingleplayer()) return [3 /*break*/, 3];
                _a.label = 1;
            case 1:
                if (!websockets_sidecar_1.websockets.isStillConnecting()) return [3 /*break*/, 3];
                return [4 /*yield*/, 0];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3:
                voyageGameMode_scenario_new_sidecar_1.voyageGameMode_scenario_new.reset();
                _a.label = 4;
            case 4:
                if (!!voyageShipSaver_sidecar_1.voyageShipSaver.getIsLoaded()) return [3 /*break*/, 6];
                return [4 /*yield*/, 0];
            case 5:
                _a.sent();
                return [3 /*break*/, 4];
            case 6:
                voyageGameMode_game_processShipFile_sidecar_1.voyageGameMode_game_processShipFile.processShipFile(false);
                voyageMessageRequestGamestate_sidecar_1.voyageMessageRequestGamestate.sendMessageRequest({});
                console.log(namespace, 'end');
                // voyageGameManager.goGame()
                return [2 /*return*/, 0];
        }
    });
}
exports.generator_clientSyncWorld = generator_clientSyncWorld;
